import React from 'react';
import './Contract.css';

const Contact = () => {
    return (
      <div className="bg-danger bg-opacity-10">
           <div className="container pt-5 pb-5 bg">
         <div>
             <h1 className="text-danger">Choose Your Best Price Plan</h1>
             <hr />
          <span className="border-bottom border-5 border-info pt-2"> <span className="text-info fs-1">Monthly</span><span className="fs-1"> /</span> <span className="fs-1">Yearly</span></span>
         </div>
         <div className="row d-flex justify-content-around">
          <div className="col-md-3 cart">
              <p>$ <span className="text-info large">100</span>/ Monthly</p>
              <h5>Monthly Checkup</h5>
              <br />
              <hr />
              <br />
              <p>Routine checkup</p>
              <p>100 Tests & Treatments</p>
              <p>24/7 Support</p>
              <p>Advanced Technology</p>
              <br />
              <hr />
              <br />
              <button className="btn btn-danger">SELECT PLAN</button>
          </div>
          <div className="col-md-3 cart">
          <p>$ <span className="text-info large">180</span>/ Monthly</p>
              <h5>Yearly Checkup</h5>
              <br />
              <hr />
              <br />
              <p>Routine checkup</p>
              <p>100 Tests & Treatments</p>
              <p>24/7 Support</p>
              <p>Advanced Technology</p>
              <br />
              <hr />
              <br />
              <button className="btn btn-danger">SELECT PLAN</button>
          </div>
          <div className="col-md-3 cart">
          <p>$ <span className="text-info large">250</span>/ Monthly</p>
              <h5>Lifetime Checkup</h5>
              <br />
              <hr />
              <br />
              <p>Routine checkup</p>
              <p>100 Tests & Treatments</p>
              <p>24/7 Support</p>
              <p>Advanced Technology</p>
              <br />
              <hr />
              <br />
              <button className="btn btn-danger">SELECT PLAN</button>
          </div>
        </div>
       </div>
      </div>
    );
};

export default Contact;